// components/ReactionVaultBanner.jsx
import React from 'react';
import '../Style/ReactionVaultBanner.css';

const REACTION_EMOJIS = {
  FIRE: '🔥',
  STRONG: '💪',
  STAR: '⭐',
  HEART: '❤️',
};

const REACTION_TYPES = ['FIRE', 'STRONG', 'STAR', 'HEART'];

const ReactionVaultBanner = ({ lifetimeCounts = {} }) => {
  const hasAny = REACTION_TYPES.some((type) => lifetimeCounts[type] > 0);

  if (!hasAny) return null;

  return (
    <div className="reaction-vault-banner">
      {REACTION_TYPES.filter((type) => lifetimeCounts[type] > 0).map((type) => (
        <div key={type} className="vault-reaction-stat">
          <span className="vault-reaction-emoji">{REACTION_EMOJIS[type]}</span>
          <span className="vault-reaction-count">{lifetimeCounts[type]}</span>
        </div>
      ))}
    </div>
  );
};

export default ReactionVaultBanner;
